var _sentryCollisionFreeGlobalObject = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["SENTRY_RELEASE"] = {"id":"94740c7ce563e7cd0766f53094941a9eae9af9b5"};
_sentryCollisionFreeGlobalObject["__sentryBasePath"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";

/* eslint-disable prefer-destructuring */
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';

const isWidgetPage = window.location.pathname.includes('/widgets');
const tracesSampleRateValue = isWidgetPage ? 0 : 0.1;

const sentryEnabled = process.env.sentryEnabled;
const sentryDsn = process.env.sentryDsn;
const environment = process.env.environment;

// Expose Sentry to window for debugging
if (typeof window !== 'undefined') {
  window.Sentry = Sentry;
}

// eslint-disable-next-line no-console
console.log('Sentry enabled', sentryEnabled);
if (sentryEnabled) {
  // eslint-disable-next-line no-console
  console.log('Sentry client initialized');
  Sentry.init({
    integrations: [
      Sentry.browserTracingIntegration({
        enableInp: true,
      }),
    ],
    dsn: sentryDsn,
    // Adjust this value in production, or use tracesSampler for greater control
    // https://develop.sentry.dev/sdk/performance/#tracessamplerate
    // https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/sampling/#setting-a-uniform-sample-rate
    tracesSampleRate: tracesSampleRateValue,

    denyUrls: [
      // Block transactions and errors on widget pages
      /^(.*?(\*?.fixter.co.uk\/widgets)[^$]*)$/,
      /^(.*?(\*?.fixter.fr\/widgets)[^$]*)$/,
      // Block Microsoft Bat script errors
      'https://bat.bing.com/bat.js',
    ],
    ignoreErrors: [
      'cookieconsent',
      'widget',
      'GraphQL error: getSession',
      '_submitInjector',
      'HTMLScriptElement.t.onload',
      'chunks/pages/_app',
      // Ignore all widget-related errors
      /widgets/,
    ],
    // ...
    // Note: if you want to override the automatic release value, do not set a
    // `release` value here - use the environment variable `SENTRY_RELEASE`, so
    // that it will also get attached to your source maps
    environment,
    beforeSend(event) {
      // console.debug('🚀 ~ beforeSend ~ event:', event);
      // Filter out hydration errors, especially those that might be caused by A/B testing
      if (
        event.exception?.values?.some((exception) => {
          const errorMsg = exception.value || '';
          // console.debug('🚀 ~ beforeSend ~ errorMsg:', errorMsg);
          return (
            // Common hydration errors
            errorMsg.includes('Hydration failed because') ||
            errorMsg.includes('Text content does not match server-rendered HTML') ||
            // Specific React hydration warnings that often occur with A/B testing
            errorMsg.includes('Expected server HTML to contain a matching') ||
            errorMsg.includes('did not match server-rendered HTML') ||
            errorMsg.includes('There was an error while hydrating') ||
            // Minified React error #425 (hydration error)
            errorMsg.includes('Minified React error #425') ||
            errorMsg.includes('Minified React error #423') ||
            errorMsg.includes('Minified React error #418')
          );
        })
      ) {
        return null;
      }
      return event;
    },
  });
}
